import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import BaseModalComponent, { StyledBaseModal } from './BaseModal.component';
import { useTranslation } from 'react-i18next';
import CalendarComponent, { DateRangeType } from '../Calendar.component';
import { useModalManager } from '../../hooks/ModalManager.hook';
import ButtonComponent from '../Button.component';

export interface DateRangeModalProps
  extends React.AllHTMLAttributes<HTMLDivElement> {
  dateRange: DateRangeType;
  handleChange: Function;
  withoutDaysAfter?: boolean;
  withoutDaysBefore?: boolean;
}

const StyledDateRangeContainerActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
const StyledDateRangeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
const StyledDateRangeWrapper = styled.div`
  ${StyledBaseModal} {
    width: 100%;
  }
`;

const DateRangeModalComponent = ({
  dateRange: _dateRange,
  handleChange: _handleChange,
  withoutDaysBefore = false,
  withoutDaysAfter = false,
}: DateRangeModalProps) => {
  const { t } = useTranslation();
  const [dateRange, setDateRange] = useState(_dateRange);
  const { closeModal } = useModalManager();

  const handleChange = useCallback(() => {
    _handleChange(dateRange);
    closeModal();
  }, [dateRange]);

  return (
    <StyledDateRangeWrapper>
      <BaseModalComponent header={t('Choose date range')}>
        <StyledDateRangeContainer>
          <CalendarComponent
            dateRange={dateRange || {}}
            withoutDaysAfter={withoutDaysAfter}
            withoutDaysBefore={withoutDaysBefore}
            onChange={setDateRange}
          />
          <StyledDateRangeContainerActions>
            <ButtonComponent appearance="primary" handleClick={handleChange}>
              {t('Apply')} & {t('Close')}
            </ButtonComponent>
            <ButtonComponent handleClick={() => closeModal()}>
              {t('Cancel')}
            </ButtonComponent>
          </StyledDateRangeContainerActions>
        </StyledDateRangeContainer>
      </BaseModalComponent>
    </StyledDateRangeWrapper>
  );
};

export default DateRangeModalComponent;
